<template>
  <div v-if="!$store.getters.getMobilePhoneActive" class="mt-4 mb-4" >
    <v-container>
      <v-flex xs10 class="mx-auto">
        <v-card class="fullContainer elevation-0 transparent">
          <v-card class="containerBackground">
            <v-container style="width:auto" grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-card class="elevation-0 mb-4 mt-2 transparent">
                    <v-layout v-if="paymentSucces" justify-left>
                      <v-card
                        round
                        color="#f2f2f2"
                        class="elevation-1"
                      >
                        <v-card-text>
                          <p
                            v-if="order.Status ==='PartnerConfirmation'"
                            class="fontSize"
                            :style="getFontProperty()"
                          >{{$translate('LINDA_MEETING_SET2')}}</p>
                          <p
                            v-else
                            class="fontSize"
                            :style="getFontProperty()"
                          >{{$translate('LINDA_MEETING_SET')}}</p>
                          <p
                            v-if="order.Status ==='PartnerConfirmation'"
                            class="fontSize"
                            :style="getFontProperty()"
                          >{{$translate('LINDA_PLANNED_SUCCESSFULL2')}}</p>
                          <p
                            v-else
                            class="fontSize"
                            :style="getFontProperty()"
                          >{{$translate('LINDA_PLANNED_SUCCESSFULL')}}</p>
                          <p
                            class="fontSize"
                            :style="getFontProperty()"
                          >{{$translate('LINDA_KEEPS_PROMISE')}}</p>
                        </v-card-text>
                      </v-card>
                    </v-layout>
                    <v-layout v-else justify-left>
                      <v-card
                        round
                        color="#f2f2f2"
                        class="elevation-1"
                      >
                        <v-card-text>
                          <p class="fontSize" :style="getFontProperty()">{{$translate('LINDA_ERROR')}}</p>
                          <p
                            class="fontSize"
                            :style="getFontProperty()"
                          >{{$translate('LINDA_ERROR_PAYMENT')}}</p>
                        </v-card-text>
                      </v-card>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6>
                  <v-card class="elevation-0 transparent">
                    <template>
                      <div>
                        <v-card class="elevation-0 transparent mb-4 ml-2">
                          <v-flex v-if="paymentSucces == true" xs12>
<!--                            <v-flex>-->
<!--                              <v-icon style="font-size: 50px;">mail_outline</v-icon>-->
<!--                              <h3 class="outlineHeadText">{{$translate("LINDA_TICKETS_TO_MAIL")}}</h3>-->
<!--                              <h4 class="outlineSecondText">{{$translate("LINDA_TICKET_INFO_ACCOUNT")}}</h4>-->
<!--                            </v-flex>-->
                            <v-btn
                              round
                              class="mt-4 text-capitalize"
                              :style="getFontProperty()"
                              color="primary"
                              block
                              large
                              @click="readyOrder()"
                            >{{$translate('LINDA_GO_TO_APPOINTMENTS')}}</v-btn>
                          </v-flex>
                          <v-flex v-if="paymentSucces == false" xs12>
                            <h3
                              class="mt-4"
                              :style="getFontProperty()"
                            >{{$translate('LINDA_ORDER_FAILED')}}</h3>
                            <v-btn
                              round
                              class="mt-4 text-capitalize"
                              :style="getFontProperty()"
                              color="primary"
                              block
                              large
                              @click="readyOrder()"
                            >{{$translate('LINDA_GO_TO_APPOINTMENTS')}}</v-btn>
                          </v-flex>
                        </v-card>
                      </div>
                    </template>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-card>
      </v-flex>
    </v-container>
      <!-- the error dialog in app.vue is not reachable so it is re-added here for internal error -->

      <v-dialog ref="snackbarError" v-model="snackbarError" persistent max-width="800">
        <v-card class="error_dialog_class">
          <v-container>
            <v-layout row align-space-between justify-space-around fill-height>
              <v-layout align-space-between justify-space-between column class="mt-4 pl-4 ml-4">
                <h2 class="headline_error">Oops...</h2>
                <h3 class="headline_error_2 mt-4">{{$translate('ERROR_HEADER')}}</h3>
                <br>
                <h3 class="headline_error_2 mt-4">{{errorText}}</h3>
                <v-layout align-end fill-height justify-end>
                  <v-btn
                    class="headline_error_btn text-capitalize"
                    flat
                    primary
                    right
                    @click.native="snackbarError = false"
                  >{{$translate('CANCEL')}}</v-btn>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
  </div>


  <div v-else class="mt-4 mb-4">
    <v-flex xs12>
      <v-card class="ml-2 mobileFullContainer elevation-0 transparent ">
        <v-card>
            <v-layout column wrap>
              <v-card class="elevation-0 transparent">
                <v-layout v-if="paymentSucces" justify-left row>
                  <v-card
                    color="green"
                    class="paymentStatusBar elevation-1">
                    <h2 class="paymentStatusBarText">{{$translate('PAYMENT_SUCCESS')}}</h2>
                  </v-card>
                </v-layout>
                <v-layout v-else justify-left row>
                  <v-card
                    color="red"
                    class="paymentStatusBar elevation-1">
                    <h2 class="paymentStatusBarText">{{$translate('PAYMENT_FAILED')}}</h2>
                  </v-card>
                </v-layout>
                <v-layout v-if="paymentSucces" justify-left>
                  <v-card
                    round
                    color="#f2f2f2"
                    class="elevation-1"
                  >
                    <v-card-title>
                      <v-flex xs2>
                        <v-icon large>warning</v-icon>
                      </v-flex>
                      <v-flex xs10>
                      <p class="fontSize"
                         :style="getFontProperty()"
                      >{{$translate('TO_APP_USERS')}}</p>
                      </v-flex>
                    </v-card-title>
                    <v-divider></v-divider>
<!--                    <v-card-text>-->
<!--                      <p-->
<!--                        class="fontSize"-->
<!--                        :style="getFontProperty()"-->
<!--                      >{{$translate('LINDA_MEETING_SET')}}</p>-->
<!--                      <p-->
<!--                        class="fontSize"-->
<!--                        :style="getFontProperty()"-->
<!--                      >{{$translate('LINDA_KEEPS_PROMISE')}}</p>-->
<!--                      <v-icon style="font-size: 50px;">mail_outline</v-icon>-->
<!--                      <h3 class="outlineHeadText">{{$translate("LINDA_TICKETS_TO_MAIL")}}</h3>-->
<!--                      <p class="outlineSecondText">{{$translate("LINDA_TICKET_INFO_ACCOUNT")}}</p>-->
<!--                    </v-card-text>-->
                    <v-btn
                      round
                      class="goToButton text-capitalize"
                      :style="getFontProperty()"
                      color="primary"
                      large
                      @click="readyOrder()"
                    >{{$translate('LINDA_GO_TO_APPOINTMENTS')}}</v-btn>
                  </v-card>
                </v-layout>
                <v-layout v-else justify-left>
                  <v-card
                    round
                    color="#f2f2f2"
                    class="elevation-1"
                  >
                    <v-card-title>
                      <v-flex xs2>
                        <v-icon large>warning</v-icon>
                      </v-flex>
                      <v-flex xs10>
                        <p class="fontSize"
                           :style="getFontProperty()"
                        >{{$translate('TO_APP_USERS')}}</p>
                      </v-flex>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <p class="fontSize" :style="getFontProperty()">{{$translate('LINDA_ERROR')}}</p>
                      <p
                        class="fontSize"
                        :style="getFontProperty()"
                      >{{$translate('LINDA_ERROR_PAYMENT')}}</p>
                      <h3
                        class="mt-4"
                        :style="getFontProperty()"
                      >{{$translate('LINDA_ORDER_FAILED')}}</h3>
                    </v-card-text>
                    <v-btn
                      round
                      class="goToButton text-capitalize"
                      :style="getFontProperty()"
                      color="primary"
                      large
                      @click="readyOrder()"
                    >{{$translate('LINDA_GO_TO_APPOINTMENTS')}}</v-btn>
                  </v-card>
                </v-layout>
              </v-card>
            </v-layout>
        </v-card>
      </v-card>
    </v-flex>

    <!-- the error dialog in app.vue is not reachable so it is re-added here for internal error -->
    <v-snackbar
      v-model="snackbarError"
      color="error"
      right
      class="snackbarError"
      multi-line
      vertical
      :timeout='5000'
    >
      <v-layout justify-center align-center column>
        <v-layout row>
          <v-icon dark medium>warning</v-icon>
          <h2>{{$translate('ERROR')}}</h2>
        </v-layout>
        <p class="headline_error_2 textPadding">{{errorText}} <b>{{errorCode}}</b></p>
        <!--         <p v-if="errorCode !=' '" class="headline_error_3"></p>-->
      </v-layout>
      <v-btn
        dark
        flat
        @click="snackbarError = false"
      >
        {{$translate('CLOSE')}}
      </v-btn>
    </v-snackbar>
  </div>




</template>

<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import MainEventInfo from "./MainEventInfo";
import BaseObject from "../objects/BaseObject";
import { ui_helpers } from "../shared/ui_helpers.js";
import BaseComponent from "./base/BaseComponent.vue";
import { setTimeout } from "timers";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: "TripOrderReady",

  computed: mapGetters({
    _webStep: "getWebStepId",
    _tripForm: "getTripForm"
  }),

  data: () => ({
    order: {},
    paymentSucces: false,
    orderData: {},
    paymentStatus: [],
    payment: "",
    paymentId: "",
    snackbarError: false,
    errorText: ''
  }),

  mounted() {
    if (this.$route.params.paymentId == undefined) {
      if(this.$store.getters.getOrderId !== ''){
        this.getMyOrder(this.$store.getters.getOrderId);
        return;
      }
      else {
        // window.EventBus.fire(
        //   "triggerGenericErrorDialog", 'E_MPID_001');
        return;
      }
    }
    // if (
    //   this.userName == "" ||
    //   this.userName == null ||
    //   this.userName == undefined
    // ) {
    //   this.snackbarError = true;
    //   this.errorText = this.$translate("USER_NOT_LOGGED_IN_TO_RETRIEVE_PAYMENTS");
    //
    //   setTimeout(() => {
    //     this.$router.push({
    //       name: "Home",
    //       params: {
    //         type: "u",
    //         account_id: this.$store.getters.getRegion
    //       }
    //     });
    //   }, 5000);
    //
    //
    // } else {
      this.paymentId = this.$route.params.paymentId;
      this.getPayment();
      this.orderData = this._tripForm.orderEvents;
    // }
  },
  methods: {
    getMyOrder(item) {
      if(!_.isEmpty(this.$store.getters["auth/userName"])){
        const payload = {
          OrderId: item
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getMyOrder was successful",
              response
            );

            if(response.data.Paid || response.data.Status === 'PartnerConfirmation')this.paymentSucces = true;
            else this.paymentSucces = false;
            this.order = response.data;
          },
          error => {
            console.log(
              "The generic call getMyOrder was not successful",
              error
            );
          },
          "getMyOrder",
          this.$store.getters["auth/userName"],
          payload
        );
      }
    },
    getPayment() {
      const payload = {
          PaymentId: this.paymentId
      };
      // This used to be the generic call getPayment
      dssRequest.doRequest(
        response => {
          console.log("The call getPayment was successful", response);
          this.paymentStatus = BaseObject._createArrayWithObjects(response.data.Payments);
          if (this.paymentStatus.length > 0) {
            this.payment = this.paymentStatus[0].PaymentStatus;
            if (this.payment == "PAID") {
              this.paymentSucces = true;
            } else {
              this.paymentSucces = false;
            }
          } else {
            this.paymentSucces = false;
          }
        },
        error => {
          console.log("The call getPayment was not successful", error);
        },
        "getPayment",
        appConfig.dss.eventAdminMng,
        payload
      );
    },

    anotherDay() {
      this._tripForm = {};
      this.goTo("MainEventInfo");
      this.$store.commit("setWebStepId", 2);

    },
    readyOrder() {
      this.goTo("TripList");
    },
    goTo(page, params = "component") {

      // Generic function to let the user move to other component
      this.$router.push({
        name: page,
        params: params
      });
    },
  }
};
</script>
<style scoped lang="scss">

  .fullContainer {
  min-height: calc(65vh);
  margin-bottom: 2em;
  }

  .mobileFullContainer {
    margin-top: 6em;
    min-height: calc(65vh);
    margin-bottom: 4em;
  }

.scrollableAuto {
  height: 20em;
  overflow-x: hidden;
  overflow-y: auto;
}

.fontSizeBig {
  font-size: 24px !important;
}

.scrollableAuto {
  height: 20em !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.paymentStatusBar {
  min-width: 100%;
  min-height: 4em;
}

.paymentStatusBarText {
  margin-left: 2em;
  margin-top: 0.8em;
}
.lindaOutline {
  margin-left: -75%;
  padding-bottom: 10px;
}

.lindaLogo {
  height: 8em;
}

.goToButton {
  margin-top: 1em;
  margin-left: 4em;
}

.lindaTextMediumTripReady {
  max-height: 19em !important;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}

.lindaText {
  border-radius: 30px !important;
  max-width: 21em !important;
}

.fontSize {
  font-size: 18px;
}

.fontSize2 {
  font-size: 16px;
}

.outlineHeadText {
  margin-left: 3.5em;
  margin-top: -3em;
}

.outlineSecondText {
  margin-top: 0.8em;
  margin-left: 0.3em;
}
</style>






